module.exports = __webpack_public_path__ + "assets/img/securitiesSolutions-bigdata.ff67787a.png";